import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import logo from './logo.svg';
import Main from './containers/main/main'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';


class App extends Component {
  render() {
    return (
      <MuiThemeProvider>
        <Router>
          <Route exact path="/" component={Main} />
        </Router>
      </MuiThemeProvider>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js